export default {
    realTimeDataText: {
      allShopText:'All Stores',//所有门店
      historyText:'History',//历史
      businessDataText:'Biz Data',//营业数据
      memberDataText:'Member data',//会员数据
      businessFlowText:'Sales Flow',//营业流水
      liushuiText:'Business flow',//流水金额
      vsLasWeekText:'Vs Last Wk',//比上周
      vsYesterDayText:'Vs Yest.',//比昨天
      ssje:'Actual Amt',//实收金额
      yhje:'Disc. Amt',//优惠金额
      yjds:'Closed Orders',//已结单数
      wjje:'Unpaid Amt',//未结金额
      wjds:'Unaccepted Orders',//未结单数
      mgcz:'Sensitive Ops',//敏感操作
      sszt:'Real-time Tables',//实时桌态
      ztzyl:'Table Occupancy Rate',//桌台占用率
      rankingText:'Rank',//排行
      djsq:'Click to Collapse',//点击收起
      lookMoreText:'See More',//查看更多
      shopText:'Store',//门店
      foodCategorizeText:'Dish Cat.',//菜品分类
      foodName:'Dish',//菜品
      numText:'Qty',//单数
      salesNumText:'Sales Qty',//销量
      fzSalesNumText:'Assist Qty',//辅助销量
      yygc:'Biz Struct.',//营业构成
      orderTypeText:'Order Type',//订单类型
      tsText:'Dine-in',//堂食
      wmText:'Delivery',//外卖
      ztText:'Pickup',//自提
      channelTypeText:'Channel Type',//渠道类型
      mtText:'Meituan',
      elmText:'Ele.me',
      posText:'POS',
      miniText:'Mini Program',
      yyqs:'Biz Trend',//营业趋势
      nowText:'Now',//当前
      lastWeekText:'Last Wk',//上周
      yesterDayText:'Yest.',//昨天
      kl:'Traffic',//客流
      peopleText:'Ppl',//人
      yuan:'CNY',//元
      xfzb:'Spend Index',//消费指标
      klrs:'Ppl Count',//客流人数
      zqkj:'Pre-disc Avg/P',//折前客均
      zhkj:'Post-disc Avg/P',//折后客均
      zqdj:'Pre-disc Avg/O',//折前单均
      zhdj:'Post-disc Avg/O',//折后单均
      cpmgcz:'Dish Ops',//菜品敏感操作
      giveFoodText:'Free (Ct/Amt)',//赠菜(次数/金额)
      returnFoodText:'Return (Ct/Amt)',//退菜(次数/金额)
      changePriceText:'Price Chg. (Ct/Amt)',//改价(次数/金额)
      discountText:'Disc. (Ct/Amt)',//打折(次数/金额)
      giveFoodText1:'Free',
      returnFoodText1:'Return',
      changePriceText1:'Price Chg.',
      discountText1:'Disc.',
      zdmgcz:'Bill Ops',//账单敏感操作
      tds:'Cancel Ct',//退单数
      xgzdcs:'Mod Bill Ct',//修改账单次数
      searchText:'Search by store name',
      nosearchdataText:'No search data available',
      orderNoText:"Bill Number",//账单号
      dishNameText:"Dish Name",//菜品名称/规格
      quantityText:"Quantity",//数量
      amountText:"Amount",//金额
      timeText:"Time",//时间
      personnelText:"Personnel",//人员
      reasonText:"Reason",//原因
      allloadedText:"All loaded",//已全部加载完
      loadingText:"Loading... ",//加载中...
      noDataText:"No data available ",//暂无数据
      zdlbText:"Bill List",//账单列表
      djzText:"P. Checkout",//待结账
      yjzText:"Paid",//已结账
      tableText1:"Table ",//桌台
      numText1:"Number of Diners",//就餐人数
      billAmountText:"Bill Amount",//账单金额
      billDetailsText:"Bill Details",//账单详情
      subtotalText:"Subtotal",//小计
      totalText:"Total",//总计
      actualPaymentText:"Actual Payment",//实收科目
      discountItemsText:"Discount Items",//优惠科目
      checkoutTimeText:"Checkout Time",//结账时间
      orderTimeText:"Order Time",//下单时间
    },
    historyDataText:{
      sjglText:'Data Overview',//数据概览
        dayText:'Day',//日
        weekText:'Week',//周
        monthText:'Month',//月'
        quarterText:'Quarter',//季
        yearText:'Year',//年'
        customText:'Custom',//自定义
        selectDateText:'Pick Date',//选择日期
        dateText:'Date',//日期
        confirmText:'Confirm',//确定
        salesFlowText:'Flow',//流水
        actualReceivedText:'Actual',//实收
        yhjezbText:'Disc. Amt/Ratio',//优惠金额/占比
        zdsText:'Bill Ct',//账单数
        klsText:'Traffic Vol.',//客流数
        zdgcText:'Bill Struct.',//账单构成
        channelText:'Channel',//渠道
        keleiText:'Cust Type',//客类
        payTypeText:'Pay Cat.',//支付科目
        tableText:'Table Stats',//桌台统计
        kaitaiText:'Open Rate',//开台率
        fantaiText:'Turnover Rate',//翻台率
        shangzuoText:'Seat Rate',//上座率
        mondayText:'Mon.',
        tuesdayText:'Tue.',
        wednesdayText:'Wed.',
        thursdayText:'Thu.',
        fridayText:'Fri.',
        saturdayText:'Sat.',
        sundayText:'Sun.',
        startText:'Start',
        endText:'End',
        realTimeText:'Real-time'
      },
      memberDataInfoText:{
        memberTotalText:"Total Members/Cards",//会员总量/卡总量
        addMemberText:"New Members",//新增会员
        addMemberCardText:"New Member Cards",//新增会员卡
        hyxfjeText:"Member Spend",//会员消费金额
        xfxjkzText:"Cash Card Consumption",//消费现金卡值
        xfzskzText:"Gift Card Consumption",//消费赠送卡值
        hyczjeText:"Member Prepaid Amount",//会员储值金额
        czxjkzText:"Cash Prepaid Value",//储值现金卡值
        czzskzText:"Gift Prepaid Value",//储值赠送卡值
        memberOrderNumText:"Member Orders",//会员订单数量
        hyldlsText:"Member-Driven Turnover",//会员拉动流水
        hyldssText:"Member-Driven Net Revenue",//会员拉动实收
        huanbiText:'MoM',//环比
        tongbiText:'YoY',//同比
       }
  }
  